module.exports = __webpack_public_path__ + "static/img/img-logo-afsi.d577db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-afsi.png
// module id = dAFN
// module chunks = 36